import { Grid } from '@mui/material';
import { WsColors, WsTypoVariants, WsTypography } from 'wisestep-base';

import { formatNumberInLocale } from '../../../../utils/NumberFormatter';
import { IAggregation } from '../../types';
import CountWithTextCard from '../countWithTextCard';

export interface ICumulativeMatricValuesChart {
  data: IAggregation[];
  title: string;
}

const CumulativeMatricValuesChart = ({ data, title }: ICumulativeMatricValuesChart) => (
  <Grid container bgcolor={WsColors.White} p={2} mb={1} mt={1}>
    <Grid item xs={12}>
      <WsTypography variant={WsTypoVariants.TITLE} bold={true}>
        {title}
      </WsTypography>
    </Grid>
    {data?.map((item) => (
      <Grid item key={item.key} xs={3} p={2}>
        <CountWithTextCard count={formatNumberInLocale(Number(item.doc_count))} text={item.key} />
      </Grid>
    ))}
  </Grid>
);

export default CumulativeMatricValuesChart;
